import React, { Component } from 'react';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
import { withRouter } from 'react-router';

const levelDescriptions = {
    gold: "(experienced professors, teaching assistants, or professional-level editors) Note: By selecting either Gold, Silver, or Bronze, you are not only paying for the depth of editing, you are selecting the level of experience your editor has with similar university papers.",
    silver: "(experienced teachers, university graduates/masters students)",
    bronze: "(teachers or 2nd year+ university students with a HIGH GPA from a top 10 university)",
}

const styles = {
    blockSpan: {
        display: 'block',
        fontSize: '20px',
        marginBottom: '10px',
        textTransform: 'capitalize',
    },
    gold: {
        color: '#D4A017',
    },
    silver: {
        color: '#C0C0C0',
    },
    bronze: {
        color: '#CD7F32',
    },
    wrapperBox: {
        marginTop: '20px',
        fontSize: '18px',
    },
    padImage: {
        marginTop: '10px',
    },
    cta: {
        fontSize: '22px',
        width: '100%',
        padding: '10px',
        marginTop: '10px',
        borderRadius: '12px',
        color: 'white',
    }
}
class LevelList extends Component{
    constructor(props){
        super(props);
        this.state = { hover: false }
    }
    toggleHover(){
        this.setState({hover: !this.state.hover})
    }
    getStarted(){
        this.props.history.push('/get-started');
        window.scroll(0,0);
    }
    render() {
        let imgPath = 'images/' + this.props.level + 'editor.jpg';
        var linkStyle;
        if (this.state.hover) {
          linkStyle = {backgroundColor: '#00C371'}
        } else {
          linkStyle = {backgroundColor: 'rgb(0, 167, 245)'}
        }
        linkStyle = Object.assign(linkStyle, styles.cta);
        return (
            <div style={styles.wrapperBox}>
                <span style={Object.assign({}, styles.blockSpan, styles[this.props.level])}>{this.props.level} Level:</span>
                { levelDescriptions[this.props.level] }
                <img style={styles.padImage} src={imgPath} />
                <button onClick={this.getStarted.bind(this)} style={linkStyle}  onMouseEnter={this.toggleHover.bind(this)} onMouseLeave={this.toggleHover.bind(this)}> Click Here To Improve Your Paper Today</button>
            </div>
        )
    }
}

export default withRouter(LevelList);



// WEBPACK FOOTER //
// ./src/components/pages/editTiers/levelList.js